"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GuidFilter = void 0;
var tslib_1 = require("tslib");
var AdvancedFilter_1 = require("./AdvancedFilter");
var GuidFilter = /** @class */ (function (_super) {
    tslib_1.__extends(GuidFilter, _super);
    function GuidFilter(fields) {
        var _this = _super.call(this) || this;
        if (typeof fields === 'object') {
            Object.assign(_this, fields);
        }
        return _this;
    }
    return GuidFilter;
}(AdvancedFilter_1.AdvancedFilter));
exports.GuidFilter = GuidFilter;
//# sourceMappingURL=GuidFilter.js.map